__turbopack_context__.v({
  "arrowCollapsed": "_61vScq_arrowCollapsed",
  "arrowExpanded": "_61vScq_arrowExpanded",
  "childTag": "_61vScq_childTag",
  "children": "_61vScq_children",
  "parentTag": "_61vScq_parentTag",
  "root": "_61vScq_root",
  "rootExpanded": "_61vScq_rootExpanded",
});
